import { number } from 'yankees-react-utils';

const mlbamPitchCodeToType = (mlbamPitchCode) => {
    const code = (mlbamPitchCode || '').toLowerCase();
    switch (code) {
    case 'fa': case 'fastball': return 1;
    case 'cs':
    case 'cu': case 'curveball': return 2;
    case 'kc': case 'knuckle curve': return 2;
    case 'sl': case 'slider': return 3;
    case 'ch': case 'changeup': return 4;
    case 'si': case 'sinker': return 9;
    case 'fs': case 'splitter': return 7;
    case 'fc': case 'cutter': return 8;
    case 'ft': case 'two-seam fb': return 9;
    case 'ff': case 'four-seam fb': return 10;
    case 'fo': return 12;
    case 'sc': return 14;
    case 'gy': return 13;
    case 'sv': case 'slurve': return 3;
    case 'st': case 'sweeper': return 3;
    default: return 0;
    }
};

const MLB_PITCHRESULT_CODES = [
    { code: 'R', description: 'Strike - Foul on Pitchout', isSwing: true, isContact: true },
    { code: 'Y', description: 'Pitchout Hit Into Play - Out(s)', isSwing: true, isContact: true },
    { code: 'M', description: 'Strike - Missed Bunt', isSwing: true, isContact: false },
    { code: 'X', description: 'Hit Into Play - Out(s)', isSwing: true, isContact: true },
    { code: 'O', description: 'Strike - Bunt Foul Tip', isSwing: true, isContact: true },
    { code: 'E', description: 'Hit Into Play - Run(s)', isSwing: true, isContact: true },
    { code: 'D', description: 'Hit Into Play - No Out(s)', isSwing: true, isContact: true },
    { code: 'Q', description: 'Strike - Swinging on Pitchout', isSwing: true, isContact: false },
    { code: 'Z', description: 'Pitchout Hit Into Play - Run(s)', isSwing: true, isContact: true },
    { code: 'F', description: 'Strike - Foul', isSwing: true, isContact: true },
    { code: 'W', description: 'Strike - Swinging Blocked', isSwing: true, isContact: false },
    { code: 'T', description: 'Strike - Foul Tip', isSwing: true, isContact: true },
    { code: 'L', description: 'Strike - Foul Bunt', isSwing: true, isContact: true },
    { code: 'C', description: 'Strike - Called', isSwing: false, isContact: false },
    { code: 'K', description: 'Strike - Unknown', isSwing: false, isContact: false },
    { code: 'J', description: 'Pitchout Hit Into Play - No Out(s)', isSwing: true, isContact: true },
    { code: 'S', description: 'Strike - Swinging', isSwing: true, isContact: false },
    { code: 'B', description: 'Ball - Called', isSwing: false, isContact: false },
    { code: 'P', description: 'Ball - Pitchout', isSwing: false, isContact: false },
    { code: 'H', description: 'Ball - Hit by Pitch', isSwing: false, isContact: false },
    { code: '*B', description: 'Ball - Ball In Dirt', isSwing: false, isContact: false },
    { code: '3', description: 'Pickoff Throw 3rd - Pitcher', isSwing: false, isContact: false },
    { code: '1', description: 'Pickoff Throw 1st - Pitcher', isSwing: false, isContact: false },
    { code: '+3', description: 'Pickoff Throw 3rd - Catcher', isSwing: false, isContact: false },
    { code: '2', description: 'Pickoff Throw 2nd - Pitcher', isSwing: false, isContact: false },
    { code: '+2', description: 'Pickoff Throw 2nd - Catcher', isSwing: false, isContact: false },
    { code: '+1', description: 'Pickoff Throw 1st - Catcher', isSwing: false, isContact: false },
    { code: 'A', description: 'Strike - Automatic', isSwing: false, isContact: false },
    { code: '.', description: 'Non Pitch', isSwing: false, isContact: false },
    { code: 'N', description: 'No Pitch', isSwing: false, isContact: false },
    { code: 'I', description: 'Ball - Intentional', isSwing: false, isContact: false },
    { code: 'V', description: 'Ball - Automatic', isSwing: false, isContact: false },
];

const pitchresultCode = (code) => {
    switch (code) {
    case 'D': return 14;
    case 'E': return 14;
    case 'X': return 14;
    case 'B': return 1;
    case 'B*': return 1;
    case 'C': return 4;
    case 'S': return 6;
    case 'W': return 6;
    case 'F': return 8;
    default: return 0;
    }
};

const baseeventCode = (code) => {
    switch (code) {
    case 'D': return 1;
    case 'E': return 1;
    case 'X': return 8;
    default: return 0;
    }
};

const hittypeCode = (code) => {
    switch (code) {
    case 'ground_ball': return 0; // GroundBall
    case 'fly_ball': return 1;// FlyBall
    case 'line_drive': return 2;// LineDrive
    case 'popup': return 3;// PopFly
    case 'bunt_grounder': return 4;// BuntGroundBall
    case 'bunt_popup': return 5;// BuntPopFly
    case 'bunt_line_drive': return 6;// BuntLineDrive
    default: return null;
    }
};

const BASE_STATES = [[], [1], [2], [1, 2], [3], [1, 3], [2, 3], [1, 2, 3]];

const bcbefore = (pitch) => {
    const bc = [
        (pitch.offense?.first ? 1 : null),
        (pitch.offense?.second ? 2 : null),
        (pitch.offense?.third ? 3 : null),
    ].filter((x) => x);
    return BASE_STATES.findIndex((b) => JSON.stringify(b) === JSON.stringify(bc));
};

const getVideoSourcesFromGuid = (guid) => {
    if (guid && guid.video && guid.video.playbackGroups) {
        return guid.video.playbackGroups.sort((a, b) => (!!a.isHomeFeed === !!b.isHomeFeed ? a.mediaSourceType - b.mediaSourceType : !!b.isHomeFeed - !!a.isHomeFeed))
            .flatMap((group) => (group.playbackRenditions ? group.playbackRenditions.sort((a, b) => b.bitrate - a.bitrate)
                .map((r) => ({
                    file: r.playbackUrl,
                    label: `${group.mediaSourceType} (${r.bitrate})`,
                    default: false,
                })) : []));
    }
    return null;
};

const buildPlaylist = (statsApiPitches, statcastGuids, translate) => {
    const playlist = [];
    (statsApiPitches ?? []).forEach((pitch) => {
        const statcastGuid = statcastGuids?.find((g) => g.guid === pitch.playId);
        const sources = getVideoSourcesFromGuid(statcastGuid);
        if (sources) sources[0].default = true;
        const clips = sources && sources.length && sources.map((v) => ({
            Url: v.file,
            AngleLabel: v.label,
            GameDate: null,
            GameID: null,
            EventSeq: null,
            PitchSeq: null,
            Include: true,
            Data: null,
        }));
        if (clips) {
            playlist.push({
                sources,
                title: `${pitch.pitchNumber}. ${pitch.matchup?.batter?.fullName} vs. ${pitch.matchup?.pitcher?.fullName}`,
                description: [
                    `${(pitch.about?.isTopInning ? translate('baseball.abbr-top') : translate('baseball.abbr-bottom'))} ${pitch.about?.inning}`,
                    `${translate('baseball.outs_other')}: ${pitch.preCount?.outs}`,
                    `${translate('baseball.count')}: ${pitch.preCount?.balls}-${pitch.preCount?.strikes}`,
                    `${pitch.details?.type?.description}, ${translate('format.abbr-mph', { value: number(pitch.pitchData?.startSpeed) })}`,
                    `${translate('common.result')}: ${pitch.details?.description}`,
                ].filter((x) => x).join(' | '),
                clip: clips,
            });
        }
    });
    return playlist;
};

const statAvg = (pitches, stat) => {
    const filteredPitches = pitches.filter((p) => p[stat]);
    if (filteredPitches.length === 0) return null;
    return filteredPitches.reduce((acc, p) => acc + p[stat], 0) / filteredPitches.length;
};

// Map the GUMBO and Statcast feeds together to make something that
// looks like the pitches table from report_pitcherpitchfx
const mapLiveDataToPpfxPitches = (game, playerId, statsApiFeed, statcastGuids) => {
    const { gameid, levelid, yearid } = game;
    const pitcherPlays = (statsApiFeed?.liveData?.plays?.allPlays ?? []).filter((play) => play.matchup?.pitcher?.id === playerId);
    // map all statsapi+statcast pitches
    return pitcherPlays.flatMap((play) => {
        const { inning, isTopInning, atBatIndex } = play.about;
        const { id: batterid, batter: fullName } = play.matchup.batter;
        return play.playEvents.filter((e) => e.isPitch).map((pitch) => {
            const statcastPitch = statcastGuids?.find((g) => g.guid === pitch.playId);
            return {
                // SITUATIONAL AND RESULT CODES
                gameid,
                levelid,
                yearid,
                playid: pitch.playId,
                pitcherid: playerId,
                pitchtype: mlbamPitchCodeToType(pitch.details?.type?.code),
                atBatIndex,
                inning,
                istop: isTopInning,
                outs: pitch.count.outs,
                outsbefore: pitch.count.outs,
                balls: pitch?.preCount?.balls ?? 0,
                strikes: pitch?.preCount?.strikes ?? 0,
                bcbefore: bcbefore(pitch),
                islhb: play.matchup.batSide.code === 'L',
                islhp: play.matchup.pitchHand.code === 'L',
                batterid,
                // eslint-disable-next-line camelcase
                batter_lastname: (fullName ?? '').split(' ').slice(1).join(' '),
                // eslint-disable-next-line camelcase
                batter_usesname: (fullName ?? '').split(' ')[0],
                batter: fullName,
                pitchresult: pitchresultCode(pitch.details?.call?.code),
                baseevent: baseeventCode(pitch.details?.call?.code),
                hittype: hittypeCode(pitch.hitData?.trajectory),
                gb: pitch.hitData?.trajectory === 'ground_ball',
                ld: pitch.hitData?.trajectory === 'line_drive',
                fb: pitch.hitData?.trajectory === 'fly_ball',
                pop: pitch.hitData?.trajectory === 'popup',
                isfirstpitch: pitch.index === play.playEvents.find((e) => e.isPitch).index,
                islastpitch: pitch.index === play.pitchIndex[play.pitchIndex.length - 1],
                twostrikepitch: pitch.preCount?.strikes === 2,
                wayahead: pitch.preCount?.strikes === 2 && pitch.preCount?.balls <= 1,
                so: pitch.index === play.pitchIndex[play.pitchIndex.length - 1] && play.result.event === 'Strikeout',
                // PITCH DATA
                initspeed54: statcastPitch?.pitchSegment?.releaseData?.releaseSpeed ?? pitch.pitchData?.startSpeed,
                breakx: statcastPitch ? statcastPitch?.pitchSegment?.trajectoryData?.horizontalBreak * -12 : pitch.pitchData?.breaks?.breakHorizontal * -1,
                breakx54: statcastPitch ? statcastPitch?.pitchSegment?.trajectoryData?.horizontalBreak * -12 : pitch.pitchData?.breaks?.breakHorizontal * -1,
                breakz: statcastPitch ? statcastPitch?.pitchSegment?.trajectoryData?.verticalBreakInduced * 12 : pitch.pitchData?.breaks?.breakVerticalInduced,
                breakz54: statcastPitch ? statcastPitch?.pitchSegment?.trajectoryData?.verticalBreakInduced * 12 : pitch.pitchData?.breaks?.breakVerticalInduced,
                initposx: statcastPitch?.pitchSegment?.releaseData?.releasePosition?.x ?? pitch.pitchData?.coordinates?.x0,
                initposz: statcastPitch?.pitchSegment?.releaseData?.releasePosition?.z ?? pitch.pitchData?.coordinates?.z0,
                spinrate: statcastPitch?.pitchSegment?.releaseData?.spinRate ?? pitch.pitchData?.breaks?.spinRate,
                spindirection: statcastPitch?.pitchSegment?.releaseData?.spinAxis ?? pitch.pitchData?.breaks?.spinDirection,
                extension: statcastPitch?.pitchSegment?.releaseData?.extension ?? pitch.pitchData?.extension,
                platex: (statcastPitch?.strikeZoneInfo?.plateX ?? statcastPitch?.pitchSegment?.trajectoryData?.location?.x ?? pitch.pitchData?.coordinates?.pX) * -1,
                platez: statcastPitch?.strikeZoneInfo?.plateZ ?? statcastPitch?.pitchSegment?.trajectoryData?.location?.z ?? pitch.pitchData?.coordinates?.pZ,
                exitvelo: statcastPitch?.hitSegment?.launchData?.speed ?? pitch.hitData?.launchSpeed,
                // BATTER ACTION, SWING FLAGS, ZONE
                stk: pitch.details.isStrike || pitch.details.isInPlay,
                tkstk: pitch.details.call.code === 'C',
                tk: pitch.details.code === 'B' || pitch.details.code === 'C',
                calledstk: pitch.details.code === 'C',
                ms: pitch.details.code === 'S',
                sw: MLB_PITCHRESULT_CODES.filter((c) => c.isSwing).map((c) => c.code).some((x) => x === pitch.details.code),
                cn: MLB_PITCHRESULT_CODES.filter((c) => c.isContact).map((c) => c.code).some((x) => x === pitch.details.code),
                szwidth: Math.max(17, statcastPitch?.strikeZoneInfo?.widthInches ?? 17),
                sztop: statcastPitch?.strikeZoneInfo?.strikeZoneTop,
                szbtm: statcastPitch?.strikeZoneInfo?.strikeZoneBottom,
                // inz: , // inz/outz/ch/etc are remapped below
                // outz: 0,
                // ch: 0,
                // swoutz: 0,
                // wellhit: 0,
                // weakhit: 0,
                // risp: false,
                // resultid: 1,
                // isinstrikezone: statcastPitch?.strikeZoneInfo?.isStrike ?? 0,
                // armangle: 38.7,
                // gyrodegree: null,
                // spinefficiency: null,
            };
        }).filter((x) => x);
    }).map((pt) => ({
        // remap to set inz based on statcast zone and pitch loc
        ...pt,
        inz: (pt.platex >= -1 * (pt.szwidth / 2)) && (pt.platex <= (pt.szwidth / 2)) && (pt.platez >= pt.szbtm) && (pt.platez <= pt.sztop),
    })).map((pt, i) => ({
        // remap pitch #, set outz/ch fields based on inz
        ...pt,
        pitchtotal: i + 1,
        outz: !pt.inz,
        swoutz: !pt.inz && pt.sw,
        ch: !pt.inz && pt.sw,
        isinstrikezone: pt.inz,
    }));
};

// Map the live fake pitches along with classification results and GUMBO data,
// producing more fake datatables to replace missing report_pitcherpitchfx results
const mapLiveDataToPpfxReport = (game, playerId, ppfx, statsApiFeed, livePitches, classifiedPitches) => {
    const { gameid, levelid, yearid, gamedate: gmdt } = game;
    const gmdtAsDate = new Date(gmdt);
    const gamedate = `${gmdtAsDate.getMonth() + 1}/${gmdtAsDate.getDate()}/${gmdtAsDate.getFullYear().toString().substring(2)}`;
    const pitcherPlays = (statsApiFeed?.liveData?.plays?.allPlays ?? []).filter((play) => play.matchup?.pitcher?.id === playerId);

    // pitches table
    ppfx.pitches = livePitches.map((p) => ({
        ...p,
        pitchtype: classifiedPitches?.find((c) => c.playid === p.playid)?.type ?? p.pitchtype,
        fxsubtype: classifiedPitches?.find((c) => c.playid === p.playid)?.fxsubtype,
    }));

    // pitchtypes table
    const pitchtypes = [...new Set(ppfx.pitches.map((p) => p.pitchtype))];
    pitchtypes.sort((a, b) => {
        // eslint-disable-next-line no-nested-ternary
        const aval = a === 1 ? 1 : (a === 10 ? 2 : (a === 9 ? 3 : a + 10));
        // eslint-disable-next-line no-nested-ternary
        const bval = b === 1 ? 1 : (b === 10 ? 2 : (b === 9 ? 3 : b + 10));
        return aval - bval;
    });
    ppfx.pitchtypes = pitchtypes.map((pitchtype, i) => ({ pitchtype, sortorder: i + 1 }));

    // gameline table - the top level statline for this game
    if (!ppfx.gameline || ppfx.gameline.length === 0) {
        ppfx.gameline = [{
            gamedate,
            gameid,
            levelid,
            yearid,
            opp: '',
            filteredlevelid: null,
        }];
    }

    const statline = [
        ...Object.values(statsApiFeed?.liveData?.boxscore?.teams?.home?.players ?? {}),
        ...Object.values(statsApiFeed?.liveData?.boxscore?.teams?.away?.players ?? {}),
    ].find((x) => x.person?.id === playerId)?.stats?.pitching ?? {};

    ppfx.gameline = ppfx.gameline.map((g) => ({
        ...g,
        pitcherid: playerId,
        gameid,
        levelid,
        yearid,
        outs: statline.outs,
        b1: statline.hits - statline.doubles - statline.triples - statline.homeRuns,
        b2: statline.doubles,
        b3: statline.triples,
        hr: statline.homeRuns,
        r: statline.runs,
        er: statline.earnedRuns,
        ubb: statline.baseOnBalls - statline.intentionalWalks,
        ibb: statline.intentionalWalks,
        hbp: statline.hitByPitch,
        so: statline.strikeOuts,
        gb: ppfx.pitches.filter((p) => p.gb).length,
        fb: ppfx.pitches.filter((p) => p.fb).length,
        ld: ppfx.pitches.filter((p) => p.ld).length,
        pop: ppfx.pitches.filter((p) => p.pop).length,
        pa: statline.battersFaced,
        pitches: statline.numberOfPitches,
        firstpstrike: ppfx.pitches.filter((p) => p.isfirstpitch && p.stk).length,
        firstp: ppfx.pitches.filter((p) => p.isfirstpitch).length,
        strikes: ppfx.pitches.filter((p) => p.stk).length,
        iballs: null,
        pitchouts: null,
        inz: ppfx.pitches.filter((p) => p.inz).length,
        outz: ppfx.pitches.filter((p) => p.outz).length,
        ch: ppfx.pitches.filter((p) => p.ch).length,
        sw: ppfx.pitches.filter((p) => p.sw).length,
        cn: ppfx.pitches.filter((p) => p.cn).length,
        calledstk: ppfx.pitches.filter((p) => p.calledstk).length,
        exitvelo: statAvg(ppfx.pitches, 'exitvelo'),
        avgexitvelo: statAvg(ppfx.pitches, 'exitvelo'),
        twostrikepitches: ppfx.pitches.filter((p) => p.strikes === 2).length,
        wayaheadpa: [...new Set(ppfx.pitches.filter((p) => p.wayahead).map((p) => p.atBatIndex))].length,
    }));

    // gamestats table - statline by pitch type splits
    ppfx.gamestats = pitchtypes.map((pitchtype) => {
        const splitPitches = ppfx.pitches.filter((p) => p.pitchtype === pitchtype);
        return {
            pitchtype,
            gameid,
            levelid,
            yearid,
            gamedate,
            hasvideo: 1,
            filteredlevelid: null,
            pitches: splitPitches.length,
            totalpitches: ppfx.pitches.length,
            stk: splitPitches.filter((p) => p.stk).length,
            tkstk: splitPitches.filter((p) => p.tkstk).length,
            tk: splitPitches.filter((p) => p.tk).length,
            cn: splitPitches.filter((p) => p.cn).length,
            ch: splitPitches.filter((p) => p.ch).length,
            inz: splitPitches.filter((p) => p.inz).length,
            outz: splitPitches.filter((p) => p.outz).length,
            gb: splitPitches.filter((p) => p.gb).length,
            ld: splitPitches.filter((p) => p.ld).length,
            fb: splitPitches.filter((p) => p.fb).length,
            pop: splitPitches.filter((p) => p.pop).length,
            bip: splitPitches.filter((p) => p.bip).length,
            ms: splitPitches.filter((p) => p.ms).length,
            sw: splitPitches.filter((p) => p.sw).length,
            initspeed54: statAvg(splitPitches, 'initspeed54'),
            breakx: statAvg(splitPitches, 'breakx'),
            breakx54: statAvg(splitPitches, 'breakx54'),
            breakz: statAvg(splitPitches, 'breakz'),
            breakz54: statAvg(splitPitches, 'breakz54'),
            initposx: statAvg(splitPitches, 'initposx'),
            initposz: statAvg(splitPitches, 'initposz'),
            spinrate: statAvg(splitPitches, 'spinrate'),
            spindirection: statAvg(splitPitches, 'spindirection'),
            extension: statAvg(splitPitches, 'extension'),
            platex: statAvg(splitPitches, 'platex'),
            platez: statAvg(splitPitches, 'platez'),
            exitvelo: statAvg(splitPitches, 'exitvelo'),
            // wellhit: 2,
            // wellhit_exctm95: 1,
            twostrikepitches: splitPitches.filter((p) => p.strikes === 2).length,
            firstp: splitPitches.filter((p) => p.isfirstpitch).length,
            firstpstrike: splitPitches.filter((p) => p.isfirstpitch && p.stk).length,
            // closepitch: 3,
            // wastepitch: 8,
            // noncomppitches: 8,
            calledstk: splitPitches.filter((p) => p.calledstk).length,
            outs: null,
            // b1: hPlays.filter((p) => p.result.event === 'Single').length,
            // b2: hPlays.filter((p) => p.result.event === 'Double').length,
            // b3: hPlays.filter((p) => p.result.event === 'Triple').length,
            // hr: hPlays.filter((p) => p.result.event === 'Home Run').length,
            // ubb: hPlays.filter((p) => p.result.event === 'Walk').length,
            // ibb: 0,
            so: splitPitches.filter((p) => p.so).length,
            // r: null,
            // er: null,
            // pa: hPlays.length,
            strikes: splitPitches.filter((p) => p.stk).length,
            pitchouts: 0,
            iballs: 0,
            wayaheadpa: [...new Set(splitPitches.filter((p) => p.wayahead).map((p) => p.atBatIndex))].length,
        };
    });

    // splits table - statline by pitch type and handedness splits
    ppfx.splits = pitchtypes.flatMap((pitchtype) => [true, false].map((islhb) => {
        const splitPitches = ppfx.pitches.filter((p) => p.islhb === islhb && p.pitchtype === pitchtype);
        return {
            splittype: `Vs. ${islhb ? 'LHB' : 'RHB'}`,
            pitchtype,
            islhb,
            gameid,
            levelid,
            yearid,
            gamedate,
            hasvideo: 1,
            filteredlevelid: null,
            pitches: splitPitches.length,
            totalpitches: ppfx.pitches.length,
            stk: splitPitches.filter((p) => p.stk).length,
            tkstk: splitPitches.filter((p) => p.tkstk).length,
            tk: splitPitches.filter((p) => p.tk).length,
            cn: splitPitches.filter((p) => p.cn).length,
            ch: splitPitches.filter((p) => p.ch).length,
            inz: splitPitches.filter((p) => p.inz).length,
            outz: splitPitches.filter((p) => p.outz).length,
            gb: splitPitches.filter((p) => p.gb).length,
            ld: splitPitches.filter((p) => p.ld).length,
            fb: splitPitches.filter((p) => p.fb).length,
            pop: splitPitches.filter((p) => p.pop).length,
            bip: splitPitches.filter((p) => p.bip).length,
            ms: splitPitches.filter((p) => p.ms).length,
            sw: splitPitches.filter((p) => p.sw).length,
            initspeed54: statAvg(splitPitches, 'initspeed54'),
            breakx: statAvg(splitPitches, 'breakx'),
            breakx54: statAvg(splitPitches, 'breakx54'),
            breakz: statAvg(splitPitches, 'breakz'),
            breakz54: statAvg(splitPitches, 'breakz54'),
            initposx: statAvg(splitPitches, 'initposx'),
            initposz: statAvg(splitPitches, 'initposz'),
            spinrate: statAvg(splitPitches, 'spinrate'),
            spindirection: statAvg(splitPitches, 'spindirection'),
            extension: statAvg(splitPitches, 'extension'),
            platex: statAvg(splitPitches, 'platex'),
            platez: statAvg(splitPitches, 'platez'),
            exitvelo: statAvg(splitPitches, 'exitvelo'),
            // wellhit: 2,
            // wellhit_exctm95: 1,
            twostrikepitches: splitPitches.filter((p) => p.strikes === 2).length,
            firstp: splitPitches.filter((p) => p.isfirstpitch).length,
            firstpstrike: splitPitches.filter((p) => p.isfirstpitch && p.stk).length,
            // closepitch: 3,
            // wastepitch: 8,
            // noncomppitches: 8,
            calledstk: splitPitches.filter((p) => p.calledstk).length,
            outs: null,
            // b1: hPlays.filter((p) => p.result.event === 'Single').length,
            // b2: hPlays.filter((p) => p.result.event === 'Double').length,
            // b3: hPlays.filter((p) => p.result.event === 'Triple').length,
            // hr: hPlays.filter((p) => p.result.event === 'Home Run').length,
            // ubb: hPlays.filter((p) => p.result.event === 'Walk').length,
            // ibb: 0,
            so: splitPitches.filter((p) => p.so).length,
            // r: null,
            // er: null,
            // pa: hPlays.length,
            strikes: splitPitches.filter((p) => p.stk).length,
            pitchouts: 0,
            iballs: 0,
            wayaheadpa: [...new Set(splitPitches.filter((p) => p.wayahead).map((p) => p.atBatIndex))].length,
        };
    }));

    // bybatterhand table - statline by islhb split
    ppfx.bybatterhand = [true, false].map((islhb) => {
        const splitPitches = ppfx.pitches.filter((p) => p.islhb === islhb);
        const hPlays = pitcherPlays.filter((p) => p.about.isComplete && p.matchup.batSide.code === (islhb ? 'L' : 'R'));
        return {
            splittype: `Vs. ${islhb ? 'LHB' : 'RHB'}`,
            islhb,
            gameid,
            levelid,
            yearid,
            gamedate,
            hasvideo: 1,
            pitches: splitPitches.length,
            totalpitches: ppfx.pitches.length,
            stk: splitPitches.filter((p) => p.stk).length,
            tkstk: splitPitches.filter((p) => p.tkstk).length,
            tk: splitPitches.filter((p) => p.tk).length,
            cn: splitPitches.filter((p) => p.cn).length,
            ch: splitPitches.filter((p) => p.ch).length,
            inz: splitPitches.filter((p) => p.inz).length,
            outz: splitPitches.filter((p) => p.outz).length,
            gb: splitPitches.filter((p) => p.gb).length,
            ld: splitPitches.filter((p) => p.ld).length,
            fb: splitPitches.filter((p) => p.fb).length,
            pop: splitPitches.filter((p) => p.pop).length,
            bip: splitPitches.filter((p) => p.bip).length,
            ms: splitPitches.filter((p) => p.ms).length,
            sw: splitPitches.filter((p) => p.sw).length,
            // spinrate: 2433.4711714285718,
            // spindirection: 150.650000,
            // extension: 6.0383999999999993,
            exitvelo: statAvg(splitPitches, 'exitvelo'),
            // wellhit: 2,
            // wellhit_exctm95: 1,
            twostrikepitches: splitPitches.filter((p) => p.strikes === 2).length,
            firstp: splitPitches.filter((p) => p.isfirstpitch).length,
            firstpstrike: splitPitches.filter((p) => p.isfirstpitch && p.stk).length,
            // closepitch: 3,
            // wastepitch: 8,
            // noncomppitches: 8,
            calledstk: splitPitches.filter((p) => p.calledstk).length,
            outs: null,
            b1: hPlays.filter((p) => p.result.event === 'Single').length,
            b2: hPlays.filter((p) => p.result.event === 'Double').length,
            b3: hPlays.filter((p) => p.result.event === 'Triple').length,
            hr: hPlays.filter((p) => p.result.event === 'Home Run').length,
            ubb: hPlays.filter((p) => p.result.event === 'Walk').length,
            ibb: 0,
            so: hPlays.filter((p) => p.result.event === 'Strikeout').length,
            r: null,
            er: null,
            pa: hPlays.length,
            strikes: splitPitches.filter((p) => p.stk).length,
            pitchouts: 0,
            iballs: 0,
            wayaheadpa: [...new Set(splitPitches.filter((p) => p.wayahead).map((p) => p.atBatIndex))].length,
        };
    });

    // cap trendpoints at # of game pitches
    ppfx.trendpoints = (ppfx.trendpoints ?? []).filter((t) => t.pitchnumber <= ppfx.pitches.length);

    return ppfx;
};

export {
    bcbefore,
    hittypeCode,
    baseeventCode,
    pitchresultCode,
    mlbamPitchCodeToType,
    buildPlaylist,
    mapLiveDataToPpfxPitches,
    mapLiveDataToPpfxReport,
    MLB_PITCHRESULT_CODES,
};
